<template>
  <div class="header" flex="main:justify">
    <div flex="cross:center">
      <div class="header__line"></div>
      <div class="header__title">{{title}}</div>
    </div>

    <div v-if="more" flex="cross:center">
      <div class="header__more">更多</div>
    </div>

    <div flex v-if="hasPicker || hasDate">
      <div v-if="hasPicker" class="header__picker">
        <el-date-picker
          style="width:250px;"
          v-model="pickerValue"
          type="daterange"
          align="right"
          size="small"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="pickTime"
        ></el-date-picker>
      </div>

      <div v-if="hasDate" class="header__picker">
        <div class="header__date" flex="cross:center">
          <div
            v-for="(item,index) in tooggleDate"
            :key="index"
            class="header__date-row"
            flex="cross:center"
            :class="tooggleDateIndex === index?'header__date-row--active':''"
            @click="onHandleToggleDate(item,index)"
          >{{item}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: 'hello world'
    },
    more: {
      type: Boolean,
      default: false
    },
    hasPicker: {
      type: Boolean,
      default: false
    },
    hasDate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    return {
      tooggleDateIndex: 0,
      tooggleDate: ['昨天', '3天', '7天', '15天', '30天'],

      pickerValue: [start, end],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  created () {},
  methods: {
    pickTime () {
      console.info('##############')
      this.$emit('refreshheader')
    },
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
      if (index == 0) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        this.pickerValue = [start, end]
        this.$emit('refreshheader')
      } else if (index == 1) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
        this.pickerValue = [start, end]
        this.$emit('refreshheader')
      } else if (index == 2) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.pickerValue = [start, end]
        this.$emit('refreshheader')
      } else if (index == 3) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
        this.pickerValue = [start, end]
        this.$emit('refreshheader')
      } else if (index == 4) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.pickerValue = [start, end]
        this.$emit('refreshheader')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-size: 0.18rem;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  &__line {
    width: 3px;
    background: rgb(16, 142, 233);
    height: 0.13rem;
    margin: 0 10px;
  }
  &__more {
    margin-right: 5px;
    color: #bfbfbf;
    font-size: 0.08rem;
  }
  &__right {
    margin-right: 15px;
    color: #bfbfbf;
  }
  &__picker {
    // margin-right: 20px;
    box-sizing: border-box;
  }
  &__date {
    height: 30px;
    margin: 0 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
    font-size: 14px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }
}
</style>
